import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  linkTo,
  linkLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-7">
      <div className="min-w-0">
        <div className="flex items-center gap-2 mb-2">
          <span className="w-4 h-[2px] bg-accent-500"></span>
          <span className="font-label text-[11px] tracking-[0.28em] text-accent-500 uppercase">
            {eyebrow}
          </span>
        </div>
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">{title}</h2>
        {description && (
          <p className="mt-2 text-sm text-foreground-500 max-w-2xl">{description}</p>
        )}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="shrink-0 hidden sm:inline-flex items-center gap-1.5 text-sm text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
        >
          {linkLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}